import React from 'react'
import { SvgIcon, DEFAULT_SIZE } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing an optidrive 3.0 Beta icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <OptidriveClockBetaIcon width={12} />
 */
const OptidriveClockBetaIcon = props => (
    <SvgIcon width={64} height={DEFAULT_SIZE} viewBox="0 0 64 24" {...props}>
        <path
            d={`M7.81,7.4L5.67,5.26C7.4,3.85,9.6,3,12,3s4.6,0.85,6.33,2.26L16.19,7.4C15.02,6.52,13.57,6,12,6S8.98,6.52,7.81,7.4z
            M19.74,6.67L17.6,8.81C18.48,9.98,19,11.43,19,13c0,1.57-0.52,3.02-1.4,4.19l2.14,2.14C21.15,17.6,22,15.4,22,13
            C22,10.6,21.15,8.4,19.74,6.67z M14.98,15.87c0.48,0.28,1.09,0.11,1.37-0.37s0.11-1.09-0.37-1.37l-3.46-2
            c-0.48-0.28-1.09-0.11-1.37,0.37c-0.28,0.48-0.11,1.09,0.37,1.37L14.98,15.87z M6.4,17.19C5.52,16.02,5,14.57,5,13
            c0-1.57,0.52-3.02,1.4-4.19L4.26,6.67C2.85,8.4,2,10.6,2,13c0,2.4,0.85,4.6,2.26,6.33L6.4,17.19z`}
        />
        <path
            d="M29.4 4h30.3C61 4 62 5 62 6.3v11.4c0 1.3-1 2.3-2.3 2.3H29.4c-1.3 0-2.3-1-2.3-2.3V6.3C27.1 5 28.2 4 29.4 4z"
            style={{ fill: '#2ddffe' }}
        />
        <g style={{ enableBackground: 'new' }}>
            <path
                style={{ fill: '#38444d' }}
                d="M24.9 4.6h3.2c.8 0 1.4.2 1.8.6.3.3.5.7.5 1.2 0 .8-.4 1.2-.9 1.5.8.3 1.3.8 1.3 1.7 0 1.2-1 1.9-2.5 1.9h-3.2V4.6zm3.9 2c0-.4-.3-.7-1-.7h-1.5v1.4h1.4c.7.1 1.1-.1 1.1-.7zm-.7 2h-1.7v1.5h1.8c.7 0 1.1-.2 1.1-.7-.1-.5-.4-.8-1.2-.8zM31.9 4.6H37V6h-3.6v1.4h3.2v1.3h-3.2v1.4h3.7v1.3h-5.2V4.6zM40 6h-2V4.6h5.6V6h-2.1v5.4H40V6zM46.2 4.6h1.4l2.9 6.8h-1.6l-.6-1.5h-2.9l-.6 1.5h-1.5l2.9-6.8zm1.6 4-.9-2.2-.9 2.2h1.8z"
                transform="translate(7.008 4)"
            />
        </g>
    </SvgIcon>
)

OptidriveClockBetaIcon.defaultProps = defaultProps

export { OptidriveClockBetaIcon }
